import { cva } from 'class-variance-authority';

export const playButtonStyles = cva(
  'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center h-12 w-12 rounded-full bg-[#2FC4FF99]',
  {
    variants: {
      size: {
        small: 'w-10 h-10',
        medium: 'w-12 h-12',
        large: 'w-20 h-20',
      },
      appearance: {},
    },
    defaultVariants: {
      size: 'medium',
    },
  }
);
